import { useModal } from "../../../customHooks/useModal";
import HeaderTitle from "../../Molecules/HeaderTitle/HeaderTitle";
import FormProfileCreate from "../../Organisms/FormProfile/FormProfileCreate";
import ModalImportMasive from "../../Organisms/ModalImportMasive/ModalImportMasive";


const columns = [
  {
    title: "Nombre",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Apellido",
    dataIndex: "lastname",
    key: "lastname",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Rol",
    dataIndex: "role",
    key: "role",
  },
];


const CreateProfileAndRole = () => {
  const [isOpenModalCreationMasive, openModalCreationMasive, closeModalCreationMasive] = useModal(false)

  const handleModalCreationMasiva = () => {
    openModalCreationMasive()
  }

  // Listado de usuarios
  const usersList = [
    {
      key: 1,
      name: 'José Antonio',
      lastname: 'Martinez',
      email: "jose.martinez@gmail.com",
      role: 'Por asignar',
    },
    {
      key: 2,
      name: 'José Antonio',
      lastname: 'Martinez',
      email: "jose.martinez@gmail.com",
      role: 'Por asignar',
    }
  ]

  return (
    <div className="nd-grid rows-gap-3">
      <HeaderTitle
        headerText="Crear un Perfil"
        downText="Cree un perfil asociado su cuenta."
        withDivider
      />

      <FormProfileCreate handleModalCreationMasiva={handleModalCreationMasiva} />

      {/* Abre el modal de la creación masiva */}
      <ModalImportMasive
        isOpenModal={isOpenModalCreationMasive} 
        closeModal={closeModalCreationMasive}
        columnsTableUserList={columns} 
        usersListToImport={usersList}
      />
    </div>
  );
};

export default CreateProfileAndRole;
